import { render, staticRenderFns } from "./CopperProductionChart.vue?vue&type=template&id=cc3e948c&lang=pug&"
import script from "./CopperProductionChart.vue?vue&type=script&lang=js&"
export * from "./CopperProductionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports